import * as React from 'react';
import { FunctionComponent } from 'react';
import { useLayoutStyles } from './styles';

interface IBwjCardProps {
  className?: string;
  cssStyles?: React.CSSProperties;
}

export const BwjCard: FunctionComponent<IBwjCardProps> = (props) => {
  const styles = useLayoutStyles();
  const classes: string[] = [];
  !!props.className && classes.push(props.className);
  classes.push(styles.card);
  
  return (
    <section className={classes.join(' ')}>
        {props.children}
    </section>
  );
};